import { useDebug } from '../contexts/DebugContext'
import AchievementsStack from './AchievementsStack'
import AchievementsTimeline from './AchievementsTimeline'

const Achievements = () => {
  const { config } = useDebug()

  // Dispatches between two layout components based on debug configuration:
  // 0 = stacked sticky cards (AchievementsStack), 1 = alternating timeline (AchievementsTimeline)
  // NOTE: Achievements must be eagerly imported (not lazy-loaded) because the sticky scroll container
  // in AchievementsStack needs correct scrollHeight on mount. Lazy loading causes resize after mount,
  // breaking progress calculations. If changing this component, ensure lazy: false in sections config.
  if (config.ACHIEVEMENTS_LAYOUT === 1) {
    return <AchievementsTimeline />
  }

  return <AchievementsStack />
}

export default Achievements
